module.exports = __webpack_public_path__ + "media/images/icons-s52269a2a5d-b49933b126b1bb9b47b847c6588dade7.png";